import styled from 'styled-components';
import { ContainerForm } from '../components/MainStyled';
import { InputTextArea } from '../../inputs/InputTextArea';

export const Container = styled(ContainerForm)`
  display: flex;
  flex-direction: column;
  width: 100%;
  gap: ${({ theme }) => theme.spaces.xxl}rem;
`;

export const DamagesContainer = styled.div``;

export const DamagesHeader = styled.div`
  display: flex;
  justify-content: space-between;
  margin: 0 0 ${({ theme }) => theme.spaces.m}rem;
`;

export const StyledInputTextArea = styled(InputTextArea)`
  max-width: 133rem;
`;

export const VehiclesContainer = styled.div``;

export const ContainerContent = styled.div`
  display: flex;
  flex-direction: column;
  width: 100%;
  gap: ${({ theme }) => theme.spaces.xl}rem;
`;

export const ContainerTitlePage = styled.div`
  display: flex;
  justify-content: space-between;
  margin: 0 0 ${({ theme }) => theme.spaces.m}rem;
`;

export const SwitchPaginationContainer = styled.div`
  display: flex;
  gap: ${({ theme }) => theme.spaces.m}rem;
`;

export const ContainerComponent = styled.div`
  display: flex;
  align-items: start;
  gap: ${({ theme }) => theme.spaces.xl}rem;
  @media (max-width: ${({ theme }) => theme.breakPoints.smallDesktop * theme.percentBaseResponsive}rem) {
    flex-direction: column;
  }
`;

export const TableContainer = styled.div`
  display: flex;
  flex-direction: column;
  gap: ${({ theme }) => theme.spaces.xl}rem;
`;

export const AdviceContainer = styled.div`
  text-align: center;
  padding: ${({ theme }) => theme.spaces.s}rem ${({ theme }) => theme.spaces.l}rem;
  border: 0.1rem solid ${({ theme }) => theme.colors.greyDark};
  /* Mismo caso que el AdviceContainer de ActionForms: "max-content" mide el
     texto en UNA línea y no tiene techo, así que en una tarjeta estrecha la
     caja se sale en vez de partir el texto. */
  width: max-content;
  max-width: 100%;
  margin: 0 auto;
`;

export const ContainerTables = styled.div`
  width: 100%;
  max-width: 133rem;
  display: flex;
  flex-direction: column;
  gap: ${({ theme }) => theme.spaces.l}rem;
`;

export const ButtonsContainer = styled.div`
  display: flex;
  gap: ${({ theme }) => theme.spaces.s}rem;
  justify-content: flex-end;
`;
